import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ITokenDetails } from '@/store/type';

const initialState: ITokenDetails = {
  tokenList: [],
};

export const baseSlice = createSlice({
  name: 'tokenList',
  initialState,
  reducers: {
    updateTokenList: (state, action: PayloadAction<ITokenDetails>) => {
      state.tokenList = action.payload.tokenList;
    },
  },
});
